<template>
    <div class="header-section">
        <p class="form-subtitle" style="cursor: pointer;" @click="$router.push('/social-events-lists')">
            <i class="fa fa-arrow-left"></i> Back
        </p>
        <h1 class="form-title">Edit Events</h1>
        <p class="form-subtitle"></p>
    </div>
    <form @submit.prevent="submitForm">
    <div class="setup-form">

        <div class="row">
             <!-- Category -->
        <div class="form-group">
        <label for="category">Category</label>
        <select id="category" required v-model="category">
            <option disabled value="">-- Select Category --</option>
            <option v-for="(data, index) in dataList" :key="index" :value="data.name">{{ data.name }}</option>
        </select>
        </div>

        <!-- Title -->
        <div class="form-group">
        <label for="title">Title</label>
        <input 
            type="text" 
            id="title"
            placeholder="Enter event title"
            required 
            v-model="title"
        />
        </div>

        <!-- Description -->
        <div class="form-group">
        <label for="description">Description</label>
        <textarea 
            id="description"
            placeholder="Type description here..." 
            rows="3" 
            required 
            v-model="description"
        ></textarea>
        </div>
        </div>

       
        <div class="row">
             <!-- Date -->
        <div class="form-group">
        <label for="date">Start Date</label>
        <input 
            type="date" 
            id="date"
            required 
            v-model="start_date"
        />

        <label for="capacity">Capacity</label>
        <input 
            type="number" 
            id="capacity"
            placeholder="Enter number of attendees"
            required 
            v-model="capacity"
        />
        <label for="capacity">Capacity Type</label>
            <input 
                type="text" 
                id="capacity"
                placeholder="Seat or players"
                required 
                v-model="capacity_type"
            />
        </div>

        <!-- Time -->
        <div class="form-group">
        <label for="time">Time</label>
        <input 
            type="time" 
            id="time"
            required 
            v-model="time"
        />
        </div>

        <!-- Venue -->
        <div class="form-group">
        <label for="venue">Venue</label>
        <input 
            type="text" 
            id="venue"
            placeholder="Enter venue"
            required 
            v-model="venue"
        />
        </div>
        </div>
       
        <div class="row">
             <!-- Capacity -->
        <div class="form-group">
            <label for="date">End Date</label>
        <input 
            type="date" 
            id="date"
            required 
            v-model="end_date"
        />
        </div>

         <!-- Amount -->
         <div class="form-group">
        <label for="amount">Program Fee</label>
        <input 
            type="text" 
            id="amount"
            placeholder="Enter program fee"
            required 
            v-model="amount"
        />
        </div>

        <!-- Status -->
        <div class="form-group">
        <label for="status">Status</label>
        <select id="status" required v-model="status">
            <option value="open">Open</option>
            <option value="closed">Closed</option>
        </select>
        </div>
         <!-- Event status -->
         <div class="form-group">
            <label for="category">Event Status</label>
            <select id="category" required v-model="event_status">
                <option disabled value="">-- Select --</option>
                <option value="free">Free</option>
                <option value="paid">Paid</option>
            </select>
            </div>
        </div>
       

    </div>

    <div class="buttons">
        <button type="submit">Submit</button>
    </div>
    </form>

</template>
<script setup>
/* eslint-disable */ 
import { CircleCheck, Image } from "lucide-vue-next";
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import axios from 'axios';
import router from "@/router";
import { useRoute } from 'vue-router'

// In setup function
const route = useRoute()

const fileInput = ref(null);
const files = ref([]);
const dataList = ref([]);
const dataListEdit = ref([]);
const created_by = ref(localStorage.getItem('userid'));

const category = ref('')
const title = ref('')
const description = ref('')
const start_date = ref('')
const end_date = ref('')
const time = ref('')
const venue = ref('')
const capacity = ref('')
const capacity_type = ref('')
const amount = ref('')
const status = ref('open')
const event_status = ref('')
let dataId = ref('');

onMounted( async () => {
    dataId.value = route.params.id
    await listRecords()
    await listRecordEdit()
});

function triggerFileInput() {
    fileInput.value.click();
}

function handleFileChange(event) {
    const selectedFile = event.target.files[0]; // only one banner at a time

    if (selectedFile) {
        const fileObj = reactive({
            name: selectedFile.name,
            file: selectedFile,
            progress: 0,
            preview: selectedFile.type.startsWith("image/")
                ? URL.createObjectURL(selectedFile)
                : null
        });
        files.value = [fileObj]; // replace with new file
    }

    event.target.value = "";
}

const listRecordEdit = async () => {
  try {
    const response = await axios.get(`/social_events_edit.php?id=${dataId.value}`, { });
    if (response.data.status){
        dataListEdit.value = response.data.data;
        category.value = dataListEdit.value.category
        title.value = dataListEdit.value.title
        description.value = dataListEdit.value.description
        start_date.value = dataListEdit.value.start_date
        end_date.value = dataListEdit.value.end_date
        time.value = dataListEdit.value.tile
        venue.value = dataListEdit.value.venue
        capacity.value = dataListEdit.value.capacity
        capacity_type.value = dataListEdit.value.capacity_type
        amount.value = dataListEdit.value.program_fee
        status.value = dataListEdit.value.status
        event_status.value = dataListEdit.value.event_status

    }
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

const listRecords = async () => {
  try {
    const response = await axios.get('/list_event_category.php', { });
    if (response.data.status) dataList.value = response.data.data;
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

async function submitForm() {
   
    const formData = new FormData();
    formData.append("id", dataId.value);
    formData.append("category", category.value);
    formData.append("title", title.value);
    formData.append("description", description.value);
    formData.append("start_date", start_date.value);
    formData.append("end_date", end_date.value);
    formData.append("time", time.value);
    formData.append("capacity", capacity.value);
    formData.append("capacity_type", capacity_type.value);
    formData.append("program_fee", amount.value);
    formData.append("venue", venue.value);
    formData.append("status", status.value);
    formData.append("event_status", event_status.value);
    formData.append("updated_by", created_by.value);


    try {
        const response = await axios.post(
            "/social_events_update.php", // change to your backend URL
            formData,
            {
                headers: { "Content-Type": "multipart/form-data" },
              
            }
        );

            alert(response.data.message);

            category.value = "";
            title.value = "";
            description.value = "";
            start_date.value = "";
            end_date.value = "";
            time.value = "";
            venue.value = "";
            capacity.value = "";
            status.value = "open"; // default
            created_by.value = "";

            router.push("/social-events-lists");
            
 
    } catch (error) {
        console.error(error);
        alert(error.response ? error.response.data.message : error.message);
    }
}
</script>
<style lang="scss" scoped>

.setup-form {
    max-width: 95%;
    margin: 0 auto;
    padding: 24px;
    display: flex;
    justify-content: between;
    gap: 24px;
    align-items: start;
}

.header-section {
    max-width: 90%;
    margin: 0 auto 20px auto;
}

.header {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
    width: 50%;
    box-shadow: #6C757D33 0px 1px 3px 0px, #6C757D1A 0px 1px 2px 0px;
    border: 1px solid #EBF1FF;
    border-radius: 20px;
    padding: 40px;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: start;
    width: 100%;
    margin-top: 20px;
}

.form-group label {
    font-size: 16px;
    color: #495057;
}

.form-group input {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #94A3B8;
    border-radius: 8px;
    font-size: 16px;
    outline: none;
    transition: border-color 0.3s;
}

.form-group select {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #94A3B8;
    border-radius: 8px;
    font-size: 16px;
    outline: none;
    transition: border-color 0.3s;
}

.form-group textarea {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #94A3B8;
    border-radius: 8px;
    font-size: 16px;
    outline: none;
    transition: border-color 0.3s;
    resize: vertical;
}

.form-group input:focus {
    border-color: #4C6EF5;
}

.buttons {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    width: 90%;
    margin: 0 auto 40px auto;
}

.buttons button {
    flex: 1;
    padding: 12px 16px;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    cursor: pointer;
    outline: none;
    transition: background-color 0.3s, color 0.3s;
}

.buttons button:first-child {
    background-color: #FF1F25;
    color: #fff;
}

.buttons button:first-child:hover {
    background-color: #c92f34;
    color: #fff;
}

.buttons button:last-child {
    background-color: #ED4E24;
    color: #fff;
}

.buttons button:last-child:hover {
    background-color: #d35533;
    color: #fff;
}

.form-title {
    text-align: left;
    font-size: 24px;
    font-weight: 600;
    margin-top: 20px;
    color: #020617;
}

.form-subtitle {
    text-align: left;
    font-size: 16px;
    color: #020617;
    margin-bottom: 20px;
}

.upload-section {
    margin-top: 20px;
    padding: 20px;
    border: 2px dashed #ccc;
    border-radius: 12px;
    text-align: center;
    background: #fafafa;
    max-width: 90%;
    height: 180px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
}

.upload-section input[type="file"] {
    display: none;
}

.file-list-section {
    max-width: 90%;
    padding: 10px;
    margin: 15px auto;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.file-item {
    background-color: #FAFAFA;
    border: 1px solid #ccc;
    width: 50%;
    margin-top: 15px;
    text-align: left;
    border-radius: 8px;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
}

.file-name {
    font-size: 12px;
    font-weight: bold;
    color: #333;
    padding: 0%;
    margin: 0%;
    width: 20%;
}

.progress-container {
    height: 4px;
    width: 80%;
    background: #eee;
    border-radius: 10px;
    position: relative;
}

.progress-bar {
    height: 100%;
    background: red;
    border-radius: 10px;
    transition: width 0.3s;
}

.progress-container span {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    font-weight: bold;
    color: #fff;
}

.file-preview {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 4px;
}

@media (max-width: 768px) {
    .setup-form {
        flex-direction: column;
        padding: 0px;
        max-width: 100%;
        margin: 0%;
    }

    .header {
        width: 100%;
        padding: 20px;
    }

    .buttons {
        flex-direction: column;
        width: 100%;
        margin: 0 auto 20px auto;
    }

    .upload-section {
        margin-top: 20px;
        padding: 20px;
        max-width: 100%;
        height: auto;
        margin: 10px auto;
    }

    .file-list-section {
        max-width: 100%;
        padding: 8px;
        margin: 12px auto;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }

    .file-item {
        background-color: #FAFAFA;
        border: 1px solid #ccc;
        width: 100%;
        margin-top: 15px;
        text-align: left;
        border-radius: 8px;
        padding: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 16px;
    }

}
</style>